import { fetchData } from "./fetchData";

//get all groups
export const getPermissionGroupNamesAPI = async() => {
    const route = `/admin/permissions/groups`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//get a user's groups
export const getUsersPermissionGroupsAPI = async(UserID) => {
    const route = `/admin/permissions/users/${UserID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//add new group
export const createPermissionGroupAPI = async(GroupData) => {
    const route = `/admin/permissions/groups`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(GroupData)
    }

    let response = await fetchData(route, options);

    return response;
}

//add users to group
export const assignPermissionGroupAPI = async(UserID, GroupID) => {
    const route = `/admin/permissions/users/${UserID}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({GroupID})
    }

    let response = await fetchData(route, options);

    return response;
}

//remove users from group
export const removePermissionGroupAPI = async(UserID, GroupID) => {
    const route = `/admin/permissions/users/${UserID}`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({GroupID})
    }

    let response = await fetchData(route, options);

    return response;
}

//get a group's permissions
export const getGroupsPermissionsAPI = async(GroupID) => {
    const route = `/admin/permissions/groups/${GroupID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}


//update group permissions
//GroupData looks like: {"permissionName": "read", "permissionResource": "runs"}

export const updateGroupPermissionsAPI = async(GroupID, GroupData) => {
    const route = `/admin/permissions/groups/${GroupID}`

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(GroupData)
    }

    let response = await fetchData(route, options);

    return response;
}

//update group details (changes to group name or description)
//GroupData looks like: {"Group_Name": "my group name","Description": "Group description"}

export const updateGroupDetailsAPI = async(GroupID, GroupData) => {
    const route = `/admin/permissions/groups/${GroupID}?details=true`

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(GroupData)
    }

    let response = await fetchData(route, options);

    return response;
}

//get a group's users
export const getGroupsUsersAPI = async(GroupID) => {
    const route = `/admin/users/groups/${GroupID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}
